export function hasImage(image = "") {
    if (
      (image.logoStream === null ||
        image.logoStream === "" ||
        image.logoStream === undefined) &&
      (image.logoPath === null ||
        image.logoPath === "" ||
        image.logoPath === undefined)
    ) {
      return false;
    }
    return true;
  }
  
  export function isValidLandingURL(url = "") {
    if (url !== "" && url !== null && url !== undefined) {
      var regex = new RegExp("^(((ht|f)tp(s?))\\://)[a-zA-Z0-9\\-\\.]+\\.[A-Za-z-]+(\\:[0-9]+)*(/($|[a-zA-Z0-9\\.\\,\\;\\?\\'\\\\+&amp;%\\$#\\=~_\\-]+))*$");
      return regex.test(url.toString().toLowerCase());
    }
    return true;
  }
  
  export function isValidCustomFeildForRule(text = "") {
    if (text !== "" && text !== null && text !== undefined) {
      if (text.toString().toLowerCase() == "email" || text.toString().toLowerCase() == "phone_number") return false;
      var regex = new RegExp("^[A-Za-z0-9]*$");
      return regex.test(text.toString().toLowerCase());
    }
    return true;
  }
  
  export function isValidCustomTagForRule(text = "") {
    if (text !== "" && text !== null && text !== undefined) {
      var regex = new RegExp("^[A-Za-z0-9]*$");
      return regex.test(text.toString().toLowerCase());
    }
    return true;
  } 

  export function isValidCustomCss(text = "") {
    if (text !== "" && text !== null && text !== undefined) {
      var regex = new RegExp("^(#|\\.)[A-Za-z0-9._-]*$");
        return regex.test(text.toString().toLowerCase());
    }
    return true;
}
